import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { Box, Grid, Typography } from "@mui/material";

const steps = ["Signed Up", "Applications", "Loans", "Accounts", "Payments"];
function ColorlibStepIcon(props: StepIconProps) {
  const { active, completed, className } = props;
  if (completed || active) {
    return <TaskAltIcon color="success" sx={{ size: 2 }} />;
  } else {
    return (
      <RadioButtonUncheckedIcon
        color="success"
        sx={{ size: 2, opacity: 0.6 }}
      />
    );
  }
}
function getStepTitle(title, status) {
  if (status) {
    return (
      <Typography
        sx={{ fontSize: "1rem", fontFamily: "Proxima Nova", color: "gray" }}
      >
        {title}
      </Typography>
    );
  } else {
    return (
      <Typography
        sx={{
          fontSize: "1rem",
          fontFamily: "Proxima Nova",
          color: "#bababaff",
        }}
      >
        {title}
      </Typography>
    );
  }
}

const CustomerStatusSteps = (props) => {
  const { verify, appCount, loanCount, plaidAccount, plaidAccount_ach } = props;
  const signStatus = 1;
  const appStatus = appCount || loanCount ? 1 : 0;
  const loanStatus = loanCount ? 1 : 0;
  const plaidAccountStatus = plaidAccount ? 1 : 0;
  const plaidAccountAchStatus = plaidAccount_ach ? 1 : 0;

  return (
    <Box
      sx={{
        width: "100%",
        paddingTop: "30px",
        height: "120px",
      }}
    >
      <Grid container>
        {steps.map((label, index) => (
          <Grid item xs={2} sx={{ textAlign: "center" }} key={`csh-${index}`}>
            <Typography className="hm-menu">
              {label == "Signed Up" && (
                <ColorlibStepIcon completed={signStatus} />
              )}
              {label == "Applications" && (
                <ColorlibStepIcon completed={appStatus} />
              )}
              {label == "Loans" && <ColorlibStepIcon completed={loanStatus} />}
              {label == "Accounts" && (
                <ColorlibStepIcon completed={plaidAccountStatus} />
              )}
              {label == "Payments" && (
                <ColorlibStepIcon completed={plaidAccountAchStatus} />
              )}
            </Typography>
            {/* <Typography>{label}</Typography> */}
            {label == "Signed Up" && getStepTitle(label, signStatus)}
            {label == "Applications" && getStepTitle(label, appStatus)}
            {label == "Loans" && getStepTitle(label, loanStatus)}
            {label == "Accounts" && getStepTitle(label, plaidAccountStatus)}
            {label == "Payments" && getStepTitle(label, plaidAccountAchStatus)}
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

const CustomerStepsHeader = ({ ...props }) => {
  const paramAppId = props.appId;
  let appId = "";
  let record = props.record;
  if (record == undefined || record == null || record == "") {
    return <></>;
  }

  let plaidAccountNum = record.plaidAccount.length;
  return (
    <>
      <CustomerStatusSteps
        verify={record.isVerify}
        appCount={record.appNum}
        loanCount={record.loanNum}
        plaidAccount={plaidAccountNum}
        plaidAccount_ach={record.plaidAccount_ach}
      />
    </>
  );
};

export default CustomerStepsHeader;
